
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");
var Promise = require("promise");

module.exports = Model({
	name: "incomingmanagementrequests",
	init: init,
	listeners: listeners,
	refresh: refresh,
	recalculate: recalculate,
	_ready: false,
});

function listeners() {
	return {
		"mqtt:$/manage/request/in/new": refresh,
		"mqtt:$/manage/request/in/accepted": refresh,
		"mqtt:$/manage/request/in/denied": refresh,
		"mqtt:$/manage/request/in/cancelled": refresh,
		"connectivity:online": refresh,
		"people:updated": handle_people_update,
		"loadchecker:ready": initial_load,
	};
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

function init() {
	this._requests = [];
	this._people = {};
	this.push([]);
}

function refresh() {
	if(!this._ready) return Promise.resolve([]);
	var token = this.config.token;
	return this.api.manage.requests
		.incoming(token)
		.then(process_requests.bind(this))
		.catch(console.error.bind(console));
}

function recalculate() {
	var people = this._people;
	this.push(merge_with_people(people, this._requests));
}

function handle_people_update(people) {
	this._people = people;
	this.recalculate();
}

function merge_with_people(people, requests) {
	return requests.map(function (request) {
		return xtend(request, {
			from: people[request.from]
		});
	});
}

function process_requests(requests) {
	var ids = get_all_ids(requests);
	if (!requests.length && this._requests.length){
		this._requests = [];
		this.push([]);
		return;
	}

	this._requests = requests;
	this.recalculate();

	this.emit("people:trigger:add", {
		lean: true,
		who: ids
	});
}

function get_all_ids(requests) {
	return Object.keys(requests.reduce(function (result, request) {
		result[request.from] = true;
		return result;
	}, {}));
}
